/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Meeting_FromInputs */

const th_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`จาก ${i?.name}`)
};

const en_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.name}`)
};

const ja_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} さんから`)
};

const zh_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`来自 ${i?.name}`)
};

const es_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`De ${i?.name}`)
};

const pt_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`De ${i?.name}`)
};

const id_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dari ${i?.name}`)
};

const fr_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`De ${i?.name}`)
};

const tl_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mula kay ${i?.name}`)
};

const vi_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Từ ${i?.name}`)
};

const ko_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}님`)
};

const de_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Von ${i?.name}`)
};

const ru_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`От ${i?.name}`)
};

const tr_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} tarafından`)
};

const it_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Da ${i?.name}`)
};

const pl_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Od ${i?.name}`)
};

const uk_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Від ${i?.name}`)
};

const hi_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} की ओर से`)
};

const ar_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`من ${i?.name}`)
};

const ms_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Daripada ${i?.name}`)
};

const bn_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}-এর কাছ থেকে`)
};

const zh_tw2_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`來自 ${i?.name}`)
};

const zh_hk2_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`來自 ${i?.name}`)
};

const ur_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} کی طرف سے`)
};

const fa_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`از ${i?.name}`)
};

const sw_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kutoka kwa ${i?.name}`)
};

const nl_meeting_from = /** @type {(inputs: Meeting_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Van ${i?.name}`)
};

/**
* | output |
* | --- |
* | "From {name}" |
*
* @param {Meeting_FromInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_from = /** @type {((inputs: Meeting_FromInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_FromInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_from(inputs)
	if (locale === "ja") return ja_meeting_from(inputs)
	if (locale === "zh") return zh_meeting_from(inputs)
	if (locale === "es") return es_meeting_from(inputs)
	if (locale === "pt") return pt_meeting_from(inputs)
	if (locale === "id") return id_meeting_from(inputs)
	if (locale === "fr") return fr_meeting_from(inputs)
	if (locale === "tl") return tl_meeting_from(inputs)
	if (locale === "vi") return vi_meeting_from(inputs)
	if (locale === "ko") return ko_meeting_from(inputs)
	if (locale === "de") return de_meeting_from(inputs)
	if (locale === "ru") return ru_meeting_from(inputs)
	if (locale === "tr") return tr_meeting_from(inputs)
	if (locale === "it") return it_meeting_from(inputs)
	if (locale === "pl") return pl_meeting_from(inputs)
	if (locale === "uk") return uk_meeting_from(inputs)
	if (locale === "hi") return hi_meeting_from(inputs)
	if (locale === "ar") return ar_meeting_from(inputs)
	if (locale === "ms") return ms_meeting_from(inputs)
	if (locale === "bn") return bn_meeting_from(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_from(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_from(inputs)
	if (locale === "ur") return ur_meeting_from(inputs)
	if (locale === "fa") return fa_meeting_from(inputs)
	if (locale === "sw") return sw_meeting_from(inputs)
	if (locale === "nl") return nl_meeting_from(inputs)
	return en_meeting_from(inputs)
});